import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { Lock, Mail } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center gap-3 mb-8">
          <img src="/icons/icon-192.png" alt="Logo SPASI" className="w-24 h-24 rounded-3xl shadow-lg" data-testid="login-logo" />
          <div className="text-center">
            <h1 className="text-4xl font-extrabold tracking-[0.3em] text-slate-100" data-testid="login-brand">SPASI</h1>
            <p className="text-sm font-medium text-emerald-600 mt-1" data-testid="login-tagline">Satu Spasi, Semua Terkoneksi</p>
          </div>
        </div>
        <form onSubmit={submit} className="bg-slate-900/90 border border-slate-800 rounded-xl p-6 space-y-4 shadow-sm" data-testid="login-form">
          <div>
            <span className="text-xs font-mono uppercase tracking-wider text-slate-400 block mb-1.5">Email</span>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="w-full bg-slate-950 border border-slate-700 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-emerald-500/60"
                placeholder="nama@perusahaan.id"
              />
            </div>
          </div>
          <div>
            <span className="text-xs font-mono uppercase tracking-wider text-slate-400 block mb-1.5">Password</span>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
              <input
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="w-full bg-slate-950 border border-slate-700 rounded-lg pl-9 pr-3 py-2.5 text-sm text-slate-100 focus:outline-none focus:border-emerald-500/60"
                placeholder="••••••••"
              />
            </div>
          </div>
          {error && <div className="text-sm text-rose-300 bg-rose-500/10 border border-rose-500/40 rounded-lg px-3 py-2" data-testid="login-error">{error}</div>}
          <button
            type="submit" disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-medium rounded-lg py-2.5 text-sm transition-colors disabled:opacity-50"
          >
            {loading ? "Memproses..." : "Masuk ke SPASI"}
          </button>
          <div className="text-center">
            <Link to="/reset-password" className="text-xs font-medium text-emerald-600 hover:text-emerald-500 transition-colors" data-testid="forgot-password-link">Lupa Password?</Link>
          </div>
          <p className="text-[11px] text-slate-500 text-center">Akun karyawan dibuat oleh Super Admin. Konsumen menerima akun setelah booking.</p>
        </form>
      </div>
    </div>
  );
}
